/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Direct_Feature_ContactInputs */

const en_home_direct_feature_contact = /** @type {(inputs: Home_Direct_Feature_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct local contact`)
};

/**
* | output |
* | --- |
* | "Direct local contact" |
*
* @param {Home_Direct_Feature_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_direct_feature_contact = /** @type {((inputs?: Home_Direct_Feature_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Direct_Feature_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_direct_feature_contact(inputs)
});